
// import { reactive } from 'vue'
// import { axiosSetting } from '@/utils/axiosSetting'

export default {
  name: 'Infomation',

  props: {
    item: Object,
    heading: {
      type: String,
      default: 'お知らせ'
    },
    simple: {
      type: Boolean,
      default: false
    }
  }

  // setup() {
  //   const getInfo = axiosSetting('cms', 'block')
  //   const infoItem = reactive<any>({})

  //   getInfo
  //     .get(
  //       `${process.env.VUE_APP_WPAPI_URL}wp-json/acf/v3/options/options/module_mini_news`
  //     )
  //     .then((res: any) => {
  //       infoItem.text = res.data.module_mini_news.text
  //       infoItem.url = res.data.module_mini_news.url
  //       infoItem.blank = res.data.module_mini_news.blank
  //     })
  // }
}
